import React from 'react';

type BalanceStatusIconProps = { remaining: number; total: number; size?: number; title: string };

const RADIUS = 6;

export const BalanceStatusIcon = ({ remaining, total, size = 24, title }: BalanceStatusIconProps) => {
  const remainingFraction = total > 0 ? Math.max(0, Math.min(1, remaining / total)) : 1;
  const angle = 2 * Math.PI * remainingFraction;
  const arcEndX = (12 + RADIUS * Math.sin(angle)).toFixed(2);
  const arcEndY = (12 - RADIUS * Math.cos(angle)).toFixed(2);
  const washPath =
    remainingFraction >= 1
      ? 'M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z'
      : `M12 12L12 6A6 6 0 ${remainingFraction > 0.5 ? 1 : 0} 1 ${arcEndX} ${arcEndY}Z`;
  return (
    <svg role="img" aria-label={title} width={size} height={size} viewBox="0 0 24 24" fill="none">
      {remainingFraction > 0 && <path d={washPath} fill="#A9E3BF" />}
      <path d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17z" stroke="#135635" strokeWidth={1.6} />
    </svg>
  );
};
